// PQR Column Definitions Configuration
export const TUBESHEET_COLUMNS = [
  {
    headerName: "Sr No.",
    cellRenderer: "PQRSrno",
    suppressMenu: true,
    pinned: "left",
    sortable: false,
    width: 100
  },
  {
    headerName: "Status",
    field: "WPSH_Status",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "WPSCellRenderer",
    pinned: "left",
    minWidth: 200,
    sort: "desc",
  },
  {
    headerName: "Year",
    field: "Wld_createdon_year",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
    pinned: "left",
    width: 150
  },
  {
    headerName: "PQR No.",
    field: "PQR_RecordNo",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
    pinned: "left",
  },
  {
    headerName: "Tubesheet Material",
    field: "PQR_BM_BM_Spec",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "P.NO.",
    field: "PQR_BM_BM_Pno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Tube Material",
    field: "PQR_BM_WTBM_Spec",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "P No.",
    field: "PQR_BM_WTBM_Pno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Diameter",
    field: "PQR_BM_WTBM_Dia",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Tube Thk",
    field: "PQR_BM_WTBM_Thk",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Joint Type",
    field: "PQR_JD_JointType",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Tube Pitch mm",
    field: "PQR_JD_TubePitch",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Tube Projection mm",
    field: "PQR_JD_TubeProj",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Pattern",
    field: "PQR_JD_Pattern",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Hole ID (mm)",
    field: "PQR_JD_HoleID",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Groove Depth (mm)",
    field: "PQR_JD_GrooveDepth",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Width of the Ligament (mm)",
    field: "PQR_JD_LigamentWidth",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Groove Angle/Radius",
    field: "PQR_JD_GrooveAngle",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Process",
    field: "WPSH_PQR_Process",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "PWHT",
    field: "PWHT",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "PWHTcheckbox",
  },
];

export const GROOVE_OVERLAY_COLUMNS = [
  {
    headerName: "Sr No.",
    cellRenderer: "PQRSrno",
    sortable: false,
    suppressMenu: true,
    pinned: "left",
    width: 100
  },
  {
    headerName: "Status",
    field: "WPSH_Status",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "WPSCellRenderer",
    pinned: "left",
    minWidth: 200,
    sort: "desc",
  },
  {
    headerName: "Year",
    field: "Wld_createdon_year",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
    pinned: "left",
    width: 150
  },
  {
    headerName: "PQR No.",
    field: "PQR_RecordNo",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
    pinned: "left",
  },
  {
    headerName: "Material 1",
    field: "PQR_BM_BM_Spec",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "P No.",
    field: "PQR_BM_BM_Pno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "G No.",
    field: "PQR_BM_BM_Gno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Base Material Condition 1",
    field: "PQR_BM_BM_ProductForm",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Material 2",
    field: "PQR_BM_WTBM_Spec",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "P No.",
    field: "PQR_BM_WTBM_Pno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "G No.",
    field: "PQR_BM_WTBM_Gno",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Base Material Condition  2",
    field: "PQR_BM_WTBM_ProductForm",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Joint",
    field: "wld_WPSType",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Thickness",
    field: "PQR_BM_BM_Thk",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Process",
    field: "WPSH_PQR_Process",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Consumable",
    field: "WPSH_PQR_Classification",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Consumable Brand",
    field: "WPSH_PQR_TradeName",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "PWHT",
    field: "PWHT",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Temp",
    field: "PQR_PWHeatTre_Temperature",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Time (Minutes)",
    field: "PQR_PWHeatTre_Time",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Impact",
    field: "Impact",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Hardness",
    field: "Hardess",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
  {
    headerName: "Code",
    field: "PQR_ReferenceCode",
    type: "Text",
    isCheckbox: false,
    cellRenderer: "",
  },
];